import { useState } from "react";
import FloatLabel from "./FloatLabel";
import ErrorLabel from "./ErrorLabel";
import { useController } from "react-hook-form";
import { HiEyeOff, HiEye } from "react-icons/hi";
import { Input, InputGroup, InputRightElement, IconButton } from "@chakra-ui/react";

export default function PasswordControl({ control, name, label, placeholder, isRequired = false, rules }) {
	const {
		field: { value = "", ...field },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label} is required`, ...rules },
	});
	const [showPassword, setShowPassword] = useState(false);

	return (
		<>
			<FloatLabel label={label} isRequired={isRequired || rules}>
				<InputGroup>
					<InputRightElement>
						<IconButton
							tabIndex="-1"
							bg="transparent !important"
							variant="ghost"
							icon={showPassword ?  <HiEye />:<HiEyeOff /> }
							onClick={() => setShowPassword(!showPassword)}
							_focus={{ outline: "none" }}
						/>
					</InputRightElement>
					<Input value={value} {...field} placeholder={placeholder} type={showPassword ? "text" : "password"} />
				</InputGroup>
				<ErrorLabel>{error?.message}</ErrorLabel>
			</FloatLabel>
		</>
	);
}
